module.exports = __webpack_public_path__ + "img/Muffin.baebccd9.svg";